module.exports = __webpack_public_path__ + "img/home_background.b4cc8bb0.jpg";